import { action, makeObservable, observable } from 'mobx';
import { splitNormalizedSearchTerms } from 'utils/textSearch';

export class UiLibrarySearchStore {
  librarySearchTerm: string = '';

  constructor() {
    makeObservable(this, {
      librarySearchTerm: observable,
      setLibrarySearchTerm: action.bound,
      clearLibrarySearch: action.bound,
    });
  }

  setLibrarySearchTerm(term: string) {
    this.librarySearchTerm = term;
  }

  clearLibrarySearch() {
    this.librarySearchTerm = '';
  }

  get hasLibrarySearch() {
    return !!this.librarySearchTerm?.trim();
  }

  get librarySearchTerms() {
    return splitNormalizedSearchTerms(this.librarySearchTerm);
  }
}
